var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rewards_and_Recog",
    "data-name": "Rewards and Recog",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.398,
    height: 84.431,
    viewBox: "0 0 58.398 84.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15048",
    "data-name": "Group 15048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M46.9,29.788V27.325A4.917,4.917,0,0,0,41.975,22.4h-15.3a4.917,4.917,0,0,0-4.925,4.925v2.463A21.354,21.354,0,0,0,12.6,47.554,21.885,21.885,0,0,0,34.411,69.189,21.62,21.62,0,0,0,56.047,47.554,21.354,21.354,0,0,0,46.9,29.788Zm-12.489,33.6A15.831,15.831,0,1,1,50.242,47.554,15.765,15.765,0,0,1,34.411,63.384Z",
    transform: "translate(-5.212 15.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M28.628,36.532v.7a3.873,3.873,0,0,1,1.407-.176h.352v-.528a.831.831,0,0,1,.879-.879H44.459a.831.831,0,0,1,.879.879v.528h.176a3.873,3.873,0,0,1,1.407.176v-.7A2.021,2.021,0,0,0,45.866,34.6L66.8,11.026,60.994,1,37.6,28.616,14.2,1,8.4,11.026,29.684,34.421A2.507,2.507,0,0,0,28.628,36.532Z",
    transform: "translate(-8.4 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M46.773,10.85,55.216,1H13l8.443,9.85Z",
    transform: "translate(-4.909 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M30.009,29.9,28.25,39.574,18.4,38.167l8.795,4.749-4.4,8.971,7.212-6.86,7.212,6.86-4.4-8.971,8.795-4.749-9.85,1.407Z",
    transform: "translate(-0.81 20.935)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestone);
export default __webpack_public_path__ + "static/media/testone.d36a4196ff2861c33f8bdc119f35973d.svg";
export { ForwardRef as ReactComponent };